module.exports = __webpack_public_path__ + "static/media/Treecko_gaussian2.b420d1a8.png";